import jwtDecode from "jwt-decode";
import { toast } from "react-toastify";
import setAuthToken from "utils/setAuthToken";
import "actions/axios-modified";

import { authenticateUser } from "actions/auth/requests";
import formErrorsHandler, { formErrorLoading } from "actions/global/form-errors-handler";

import {
  AUTH_USER_SET,
  AUTH_LOADING
} from "actions/auth/constants";

export const setLoading = (status) => ({
  type: AUTH_LOADING,
  payload: status
});

// Login - Get User Token
export const loginUser = (userData) => dispatch => {
  dispatch(setLoading(true));
  authenticateUser(userData.username, userData.password)
    .then(response => {
      dispatch(formErrorLoading(false));
      // Save to localStorage
      const {
        token,
        roles
        // refreshToken
      } = response.data.content;
      // Set token to ls
      localStorage.setItem("jwtToken", token);
      localStorage.setItem("roles", JSON.stringify(roles));
      // localStorage.setItem("refreshToken", refreshToken);
      // Set token to Auth header
      setAuthToken(token);
      // Decode token to get user data
      const user = jwtDecode(token);

      toast("You are logged in successfully", {
        type: toast.TYPE.SUCCESS,
      });

      // Set current user
      dispatch({
        type: AUTH_USER_SET,
        payload: {
          user,
          roles
        }
      });
    })
    .catch(() => {
      dispatch(formErrorsHandler("Login failed. Please input correct name and password!"));
    });
};

// Log user out
export const logoutUser = () => dispatch => {
  // Remove token from localStorage
  localStorage.removeItem("jwtToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("roles");
  // Remove auth header for future requests
  setAuthToken(false);
  // Set current user to {} which will set isAuthenticated to false
  dispatch({
    type: AUTH_USER_SET,
    payload: {}
  });
  window.location.href = "/";
};



// WEBPACK FOOTER //
// ./src/actions/auth/actions.js